<div class="expired-invite-root" *transloco="let t">
  <app-epson-logo></app-epson-logo>
  <app-label isBig>{{t('your-invite-link-has-expired')}}</app-label>
  <app-paragraph>{{t('sorry-invitation-link-has-expired-info')}}</app-paragraph>
  <app-primary-button [routerLink]="homeRoute">{{t('go-to-epson-rewards-landing-page')}}</app-primary-button>
</div>
